//@ts-nocheck
import SplitText from "../components/splitText";
import { datalayers } from "../config/datalayers";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { loadSwiperSliderBeer } from "../components/sliderBeer";

declare global {
  interface Window {
    dataLayer: any;
  }
}

window.dataLayer = window.dataLayer || [];

fetch('/150porciento/user/check/user').then(response => {
  console.log(response);
  if(response.status == 401) {
    const allBtns = document.querySelectorAll('.bannerSlider--link.loginBtnLink')
    allBtns.forEach(element => {
      element.addEventListener('click', e => {
        e.preventDefault();
        console.log('open login box', element.id);
        window.drupalLogin(element.id)
      })
    })
  }
  return response.json();
}).then(response => {
  console.log('json res', response);
})

// import KeenSlider from 'keen-slider'
window.addEventListener("load", () => {
  // removeLabels()
  // setTimeout(() =>  datalayers(), 1000)
  loadVideoIframe();
  loadSwiperSliderBeer();
  // loadSwiperProducts();
  addCorosVideoGallery();
  datalayers();
  loadDataLayerProducts();

  new SplitText(".sliderBeer--title");
  new SplitText(".coros-gallery--header h3");
  new SplitText(".somos-presidente-products--title h3");
});

const loadDataLayerProducts = () => {
  let flagDataLayer = true;
  const blockProductsHome = document.querySelector(
    ".somos-presidente-products"
  ) as HTMLElement;

  if (blockProductsHome) {
    gsap.to(".somos-presidente-products", {
      scrollTrigger: {
        trigger: ".somos-presidente-products",
        start: "top bottom",
        end: "bottom bottom",
        onEnter: () => {
          if (flagDataLayer) {
            window.dataLayerProductHome();
            flagDataLayer = false;
          }
        },
      },
    });
  }
};

const loadVideoIframe = () => {
  const wrapper = document.querySelector(
    ".basic_video__content-wrapper"
  ) as HTMLElement;
  const iframe = document.querySelector(
    ".basic_video__content--player"
  ) as HTMLIFrameElement;
  const urlDiv = document.querySelector(
    ".basic_video__content--urlVideo div"
  ) as HTMLElement;
  const urlVideo = urlDiv.textContent;

  if (!!urlDiv) {
    const urlParams = new URL(urlVideo).searchParams.get("v");

    const urlIframe = `https://www.youtube.com/embed/${urlParams}?enablejsapi=1`;

    iframe.src = urlIframe;

    wrapper.addEventListener("click", () => {
      wrapper.classList.add("played");
      setTimeout(() => {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
      }, 500);
    });
  }
};

// const loadSwiperProducts = () => {
//   const swiper = new Swiper(".somos-presidente-products .swiper-products", {
//     spaceBetween: 30,
//     slidesPerView: 1,
//     breakpoints: {
//       480: {
//         slidesPerView: 2,
//         spaceBetween: 20,
//       },
//       1024: {
//         slidesPerView: 3,
//         spaceBetween: 30,
//       },
//     },
//     navigation: {
//       nextEl: ".somos-presidente-products .swiper-products .swiper-button-next",
//       prevEl: ".somos-presidente-products .swiper-products .swiper-button-prev",
//     },
//   });
// };

const addCorosVideoGallery = () => {
  // window load
  const corosGallery = document.querySelectorAll(".coros-gallery .views-row");

  corosGallery.forEach((coro) => {
    const videoUrl = coro.querySelector(
      ".views-field-field-video .field-content"
    ).textContent;
    const titleCoro = coro.querySelector(
      ".views-field-field-title .field-content"
    ).textContent;
    const urlParams = new URL(videoUrl).searchParams.get("v");

    const urlIframe = `https://www.youtube.com/embed/${urlParams}?enablejsapi=1`;
    const urlImg = `https://img.youtube.com/vi/${urlParams}/hqdefault.jpg`;

    // coro css background
    coro.style.backgroundImage = `url(${urlImg})`;

    coro.addEventListener("click", () => {
      const player = document.querySelector(
        ".iframe-video-player"
      ) as HTMLIFrameElement;
      player.src = urlIframe;
      setTimeout(() => {
        player.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
      }, 1500);
      openModal(player);

      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Presidente Largo Plazo 2022", // Categoría del evento (String). Requerido.
        eventAction: "Nuestros Coros ", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: titleCoro, // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  });
};

const openModal = (player) => {
  const modal = document.querySelector(".modal-video") as HTMLElement;
  modal.classList.add("modal-open");

  modal.querySelector(".modal-close").addEventListener("click", () => {
    modal.classList.remove("modal-open");
    player.src = "";
  });
};

const datalayers = () => {
  let btnBannerSlider = document.querySelectorAll(".bannerSlider--link") as any;
  if (btnBannerSlider) {
    let arrayBtns = [...btnBannerSlider];
    arrayBtns.forEach((element) => {
      element.addEventListener("click", (e: any) => {
        let wrapper = e.target.closest(".bannerSlider--content");
        let nameProduct = wrapper.querySelector(".bannerSlider--title h2");
        if (nameProduct) {
          window.dataLayer.push({
            event: "trackEvent",
            eventCategory: "Presidente Largo Plazo 2022", // Categoría del evento (String). Requerido.
            eventAction: "Descubre Aqui- Banner Home", // Acción o subcategoría del evento (String). Requerido.
            eventLabel: nameProduct.textContent ?? '', // Etiqueta de descripción del evento (String). Requerido.
          });
        }
      });
    });
  }

  let btnContentSomosPresidente = document.querySelector(
    ".path-home #block-do-presidente-content article div div p a"
  ) as any;
  if (btnContentSomosPresidente) {
    btnContentSomosPresidente.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Presidente Largo Plazo 2022", // Categoría del evento (String). Requerido.
        eventAction: "Descubre Aquí- La fría que todos quieren", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: "Clic", // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  }

  let btnSliderBeers = document.querySelectorAll(".swiper-slide--link") as any;
  if (btnSliderBeers) {
    let arrayBtns = [...btnSliderBeers];
    arrayBtns.forEach((element) => {
      element.addEventListener("click", (e: any) => {
        let wrapper = e.target.closest(".swiper-slide");
        let nameProduct = wrapper.querySelector(".swiper-slide--title");
        if (nameProduct) {
          window.dataLayer.push({
            event: "trackEvent",
            eventCategory: "Presidente Largo Plazo 2022", // Categoría del evento (String). Requerido.
            eventAction: "Conoce más -Tu fría Favorita", // Acción o subcategoría del evento (String). Requerido.
            eventLabel: nameProduct.textContent, // Etiqueta de descripción del evento (String). Requerido.
          });
        }
      });
    });
  }

  let btnCorosFooter = document.querySelector(
    ".coros-gallery--footer a"
  ) as any;
  if (btnCorosFooter) {
    btnCorosFooter.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Presidente Largo Plazo 2022", // Categoría del evento (String). Requerido.
        eventAction: "Conoce más -Nuestros Coros", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: "Clic", // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  }
};
